export const illinois = {
  "17000": "Illinois",
  "17001": "Adams County",
  "17003": "Alexander County",
  "17005": "Bond County",
  "17007": "Boone County",
  "17009": "Brown County",
  "17011": "Bureau County",
  "17013": "Calhoun County",
  "17015": "Carroll County",
  "17017": "Cass County",
  "17019": "Champaign County",
  "17021": "Christian County",
  "17023": "Clark County",
  "17025": "Clay County",
  "17027": "Clinton County",
  "17029": "Coles County",
  "17031": "Cook County",
  "17033": "Crawford County",
  "17035": "Cumberland County",
  "17037": "DeKalb County",
  "17039": "De Witt County",
  "17041": "Douglas County",
  "17043": "DuPage County",
  "17045": "Edgar County",
  "17047": "Edwards County",
  "17049": "Effingham County",
  "17051": "Fayette County",
  "17053": "Ford County",
  "17055": "Franklin County",
  "17057": "Fulton County",
  "17059": "Gallatin County",
  "17061": "Greene County",
  "17063": "Grundy County",
  "17065": "Hamilton County",
  "17067": "Hancock County",
  "17069": "Hardin County",
  "17071": "Henderson County",
  "17073": "Henry County",
  "17075": "Iroquois County",
  "17077": "Jackson County",
  "17079": "Jasper County",
  "17081": "Jefferson County",
  "17083": "Jersey County",
  "17085": "Jo Daviess County",
  "17087": "Johnson County",
  "17089": "Kane County",
  "17091": "Kankakee County",
  "17093": "Kendall County",
  "17095": "Knox County",
  "17097": "Lake County",
  "17099": "La Salle County",
  "17101": "Lawrence County",
  "17103": "Lee County",
  "17105": "Livingston County",
  "17107": "Logan County",
  "17109": "McDonough County",
  "17111": "McHenry County",
  "17113": "McLean County",
  "17115": "Macon County",
  "17117": "Macoupin County",
  "17119": "Madison County",
  "17121": "Marion County",
  "17123": "Marshall County",
  "17125": "Mason County",
  "17127": "Massac County",
  "17129": "Menard County",
  "17131": "Mercer County",
  "17133": "Monroe County",
  "17135": "Montgomery County",
  "17137": "Morgan County",
  "17139": "Moultrie County",
  "17141": "Ogle County",
  "17143": "Peoria County",
  "17145": "Perry County",
  "17147": "Piatt County",
  "17149": "Pike County",
  "17151": "Pope County",
  "17153": "Pulaski County",
  "17155": "Putnam County",
  "17157": "Randolph County",
  "17159": "Richland County",
  "17161": "Rock Island County",
  "17163": "St. Clair County",
  "17165": "Saline County",
  "17167": "Sangamon County",
  "17169": "Schuyler County",
  "17171": "Scott County",
  "17173": "Shelby County",
  "17175": "Stark County",
  "17177": "Stephenson County",
  "17179": "Tazewell County",
  "17181": "Union County",
  "17183": "Vermilion County",
  "17185": "Wabash County",
  "17187": "Warren County",
  "17189": "Washington County",
  "17191": "Wayne County",
  "17193": "White County",
  "17195": "Whiteside County",
  "17197": "Will County",
  "17199": "Williamson County",
  "17201": "Winnebago County",
  "17203": "Woodford County",
};
